var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"text-center"},[_c('div',{staticClass:"step-indicator"},_vm._l((_vm.totalSteps),function(step){return _c('div',{key:step,class:{'step': true, 'current': step === _vm.currentStep, 'complete': step < _vm.currentStep}},[_vm._v(_vm._s(step))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }